/**
 * 에피소드 리뷰 **결과** 축의 한글 표시 문구(제품 카피, FE 소유).
 *
 * 값은 서버 bool `task_failed` 다. `true` 는 실패이고 `false` 는 기본 성공이다. 새 에피소드는
 * `false` 로 시작한다. 그래서 `false` 는 사람이 성공을 확인했다는 뜻이 아니다. 이 문구는 `false` 를
 * `성공` 이라고 쓰지 않고 `기본 성공` 이라고 쓴다. 검토 완료 여부는 이 축과 독립이다(`review_state`).
 *
 * 결함 유형(`episodeQualityTags.ts`)과도 독립이다. 실패여도
 * 결함 태그가 비어 있을 수 있다(사유 미기록).
 */
export const EPISODE_FAILURE_LABELS = {
  failure: { ko: "실패", tip: "작업을 완수하지 못한 에피소드입니다." },
  defaultSuccess: {
    ko: "기본 성공",
    tip: "실패로 표시하지 않은 에피소드입니다. 사람이 성공을 확인했다는 뜻은 아닙니다.",
  },
} as const;

// 결과 → 한글 라벨(필터 옵션·배지에 쓴다).
export function episodeFailureLabel(taskFailed: boolean): string {
  return taskFailed ? EPISODE_FAILURE_LABELS.failure.ko : EPISODE_FAILURE_LABELS.defaultSuccess.ko;
}

// 결과 → 설명 툴팁.
export function episodeFailureTip(taskFailed: boolean): string {
  return taskFailed
    ? EPISODE_FAILURE_LABELS.failure.tip
    : EPISODE_FAILURE_LABELS.defaultSuccess.tip;
}
